// WRAP LUXURY - small storefront enhancements.

// Product cards: hovering a colour swatch previews that colour's image on the card.
document.addEventListener('mouseover', (event) => {
  const swatch = event.target.closest('.wl-card-swatches__swatch[data-card-image]');
  if (!swatch) return;
  const card = swatch.closest('.card-wrapper');
  const img = card && card.querySelector('.card__media img');
  if (!img) return;
  if (!img.dataset.wlOriginalSrc) {
    img.dataset.wlOriginalSrc = img.currentSrc || img.src;
    img.dataset.wlOriginalSrcset = img.getAttribute('srcset') || '';
  }
  img.removeAttribute('srcset');
  img.src = swatch.dataset.cardImage;
  card.classList.add('wl-swatch-preview');
});

document.addEventListener('mouseout', (event) => {
  const swatch = event.target.closest('.wl-card-swatches__swatch[data-card-image]');
  if (!swatch || swatch.contains(event.relatedTarget)) return;
  const card = swatch.closest('.card-wrapper');
  const img = card && card.querySelector('.card__media img');
  if (!img || !img.dataset.wlOriginalSrc) return;
  // Stay on the previewed colour while moving between swatches.
  if (event.relatedTarget && event.relatedTarget.closest && event.relatedTarget.closest('.wl-card-swatches')) return;
  img.src = img.dataset.wlOriginalSrc;
  if (img.dataset.wlOriginalSrcset) img.setAttribute('srcset', img.dataset.wlOriginalSrcset);
  card.classList.remove('wl-swatch-preview');
});
